// Session role defaults used by resolveUserPermissions (login / verify-email).
export const SYSTEM_ROLES = {
  admin: {
    id: 'admin',
    name: 'Admin',
    description: 'Full access to all features',
    isSystem: true,
    permissions: {
      dashboard: true,
      liveChat: true,
      analytics: true,
      settings: true,
      userManagement: true,
      contentManagers: true,
      contentPublish: true,
      requests: true,
      requestsManage: true,
      requestsNotify: true,
      requestsManualChat: true,
      requestsSensitive: true,
      comments: true,
      commentsManage: true,
      channelWhatsapp: true,
      channelInstagram: true,
      channelFacebook: true,
      channelTiktok: true,
      channelWeb: true
    }
  },
  platform_owner: {
    id: 'platform_owner',
    name: 'Platform Owner',
    description: 'Linas AI platform operator (CLI-provisioned only; not assignable in-app)',
    isSystem: true,
    assignableInTenantUi: false,
    permissions: {
      dashboard: true,
      liveChat: true,
      analytics: true,
      settings: true,
      userManagement: true,
      contentManagers: true,
      contentPublish: true,
      requests: true,
      requestsManage: true,
      requestsNotify: true,
      requestsManualChat: true,
      requestsSensitive: true,
      comments: true,
      commentsManage: true,
      channelWhatsapp: true,
      channelInstagram: true,
      channelFacebook: true,
      channelTiktok: true,
      channelWeb: true
    }
  },
  operator: {
    id: 'operator',
    name: 'Operator',
    description: 'Can handle chats and view analytics',
    isSystem: true,
    permissions: {
      dashboard: true,
      liveChat: true,
      analytics: true,
      settings: false,
      userManagement: false,
      contentManagers: false,
      contentPublish: false,
      requests: true,
      requestsManage: true,
      requestsNotify: true,
      requestsManualChat: true,
      requestsSensitive: false,
      comments: true,
      commentsManage: true,
      channelWhatsapp: true,
      channelInstagram: true,
      channelFacebook: true,
      channelTiktok: true,
      channelWeb: true
    }
  },
  viewer: {
    id: 'viewer',
    name: 'Viewer',
    description: 'Read-only access to dashboard and history',
    isSystem: true,
    permissions: {
      dashboard: true,
      liveChat: false,
      analytics: true,
      settings: false,
      userManagement: false,
      contentManagers: false,
      contentPublish: false,
      requests: false,
      requestsManage: false,
      requestsNotify: false,
      requestsManualChat: false,
      requestsSensitive: false,
      comments: false,
      commentsManage: false,
      channelWhatsapp: true,
      channelInstagram: true,
      channelFacebook: true,
      channelTiktok: true,
      channelWeb: true
    }
  }
};

export const DEFAULT_PERMISSIONS = {
  dashboard: false,
  liveChat: false,
  analytics: false,
  settings: false,
  userManagement: false,
  contentManagers: false,
  contentPublish: false,
  requests: false,
  requestsManage: false,
  requestsNotify: false,
  requestsManualChat: false,
  requestsSensitive: false,
  comments: false,
  commentsManage: false,
  channelWhatsapp: true,
  channelInstagram: true,
  channelFacebook: true,
  channelTiktok: true,
  channelWeb: true
};

export const PERMISSION_KEYS = Object.keys(DEFAULT_PERMISSIONS);
